var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 38,
    viewBox: "0 0 35 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8333 8.08197L12.1667 3.36066M22.8333 8.08197L31.9469 2.03117C32.6116 1.58987 33.5 2.06643 33.5 2.86427V27.6111C33.5 27.9462 33.3322 28.2589 33.0531 28.4442L22.8333 35.2295M22.8333 8.08197V35.2295M12.1667 3.36066L1.98011 9.56026C1.68197 9.74171 1.5 10.0655 1.5 10.4145V35.2208C1.5 36.0009 2.35349 36.4806 3.01989 36.075L12.1667 30.5082M12.1667 3.36066V30.5082M12.1667 30.5082L22.8333 35.2295",
    stroke: "#2F076F",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaps);
export default __webpack_public_path__ + "static/media/maps.f447fd7445a9892f0b8af1ed144bb5f4.svg";
export { ForwardRef as ReactComponent };